import React from 'react';

const FIELDS = ['INPUT', 'TEXTAREA', 'SELECT'];

/**
 * Closes an open box on Escape when focus sits outside a form field.
 *
 * This is the window-level half of a pair: the box's own input handles Escape
 * while it has focus, and this catches the case where focus has moved on — or
 * where a browser extension swallowed the first Escape to blur the field. Both
 * halves are needed; neither covers the other's case.
 *
 * Deliberately registered on every render rather than against a dependency
 * list, so `onClose` is never captured stale.
 */
export default function useEscapeToClose(active, onClose) {
  React.useEffect(() => {
    if (!active) return undefined;
    const handleEscape = (e) => {
      if (e.key !== 'Escape') return;
      if (FIELDS.includes(e.target.tagName)) return;
      onClose();
    };
    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  });
}
